// Copyright (c) 2016 Deere & Company

import './index.scss';
import React, {PropTypes} from 'react';
import ClaimValueDetails from '@deere/cps-it.warranty-model-factory/lib/claim-value-details';
import LabeledCurrency from '../../../../shared/components/labeled-currency';
import LaborValue from './labor-value';
import OtherCreditsValue from './other-credits-value';
import PartsValue from './parts-value';

const ClaimValueSummary = props =>
    <section className='claim-value-details'>
        <PartsValue
            coreValues={props.values.coreValues}
            onShelfCost={props.values.onShelfCost}
            partAdditive={props.values.partAdditive}
            partValues={props.values.partValues}
            partsTotal={props.values.partsTotal}
        />
        <LaborValue
            laborAdditive={props.values.laborAdditive}
            laborTotal={props.values.laborTotal}
            laborValue={props.values.laborValue}
        />
        <OtherCreditsValue
            nonTravel={props.values.nonTravel}
            otherCreditTotal={props.values.otherCreditTotal}
            travel={props.values.travel}
        />
        <section className='claim-value-total'>
            <LabeledCurrency
                className='claim-value-header'
                data={props.values.totalAmount}
                label='VALUE'
            />
        </section>
    </section>;

ClaimValueSummary.displayName = 'ClaimValueSummary';
ClaimValueSummary.propTypes = {
    values: PropTypes.instanceOf(ClaimValueDetails).isRequired
};

export default ClaimValueSummary;



// WEBPACK FOOTER //
// ./src/claim/shared/components/claim-value/claim-value-summary.js